import { Component, output } from '@angular/core';
import {
  GcModalComponent,
  GcTextComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';

@Component({
  selector: 'app-overwrite-reports-confimation-modal',
  imports: [GcModalComponent, IpoTranslatePipe, GcTextComponent],
  templateUrl: './overwrite-reports-confimation-modal.component.html',
  styleUrl: './overwrite-reports-confimation-modal.component.scss',
})
export class OverwriteReportsConfimationModalComponent {
  confirm = output();
  cancel = output();

  handleOnClickConfirm(): void {
    this.confirm.emit();
  }

  handleOnClickCancel(): void {
    this.cancel.emit();
  }
}
